var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.feature.locales.includes(_vm.$i18n.locale))?_c('dd',{staticClass:"subscription-plan-feature plans__feature__item plans__feature__item--extra",domProps:{"innerHTML":_vm._s(_vm.featureLabel)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }